export default __webpack_public_path__ + "static/media/icon_lupe_grafik.fdc5f533.png";